<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-card header="公司数" class="text">
          <div class="text item">{{ lastStatistics.company_count }}</div>
        </el-card>
      </el-col>
      <el-col :span="3">
        <el-card header="用户数" class="text">
          <div class="text item">{{ lastStatistics.user_count }}</div>
        </el-card>
      </el-col>
      <el-col :span="3">
        <el-card header="招聘者数" class="text">
          <div class="text item">{{ lastStatistics.recruiter_count }}</div>
        </el-card>
      </el-col>
      <el-col :span="3">
        <el-card header="求职者数" class="text">
          <div class="text item">{{ lastStatistics.job_seeker_count }}</div>
        </el-card>
      </el-col>
      <el-col :span="3">
        <el-card header="职位数" class="text">
          <div class="text item">{{ lastStatistics.job_count }}</div>
        </el-card>
      </el-col>
      <el-col :span="3">
        <el-card header="简历数" class="text">
          <div class="text item">{{ lastStatistics.resume_count }}</div>
        </el-card>
      </el-col>
      <el-col :span="3">
        <el-card header="职位浏览数" class="text">
          <div class="text item">{{ lastStatistics.job_view_count }}</div>
        </el-card>
      </el-col>
      <el-col :span="3">
        <el-card header="简历浏览数" class="text">
          <div class="text item">{{ lastStatistics.resume_view_count }}</div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card header="系统信息" class="text">
          <div class="item">OS: {{ systeminfo.os }}</div>
          <div class="item">Arch: {{ systeminfo.arch }}</div>
          <div class="item">Cpu: {{ systeminfo.numCpu }}</div>
          <div class="item">Go version: {{ systeminfo.goversion }}</div>
          <div class="item">Hostname: {{ systeminfo.hostname }}</div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      systeminfo: null,
      lastStatistics: null,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.systeminfo = await this.axios.get("/api/admin/common/systeminfo");
      this.lastStatistics = await this.axios.get("/api/admin/statistics/last");
    },
  },
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.text {
  font-size: 15px;
  font-weight: bold;
}

.item {
  margin-bottom: 18px;
}
</style>
